import { useEffect } from 'react';

/**
 * Warn before the tab closes on unsaved wizard input.
 *
 * The drafts are debounced by 400ms, so a hard navigation or tab close inside that window
 * loses the last keystrokes with no warning. `SurveyBuilder` had this guard from the
 * start; `/simulate` and `/build-audience` did not — the same sibling gap this spec keeps
 * finding, in my own R8 requirement ("beforeunload while dirty").
 *
 * Only armed while `hasWork` — a confirm dialog on an empty wizard is the kind of prompt
 * people learn to dismiss without reading, which makes it useless when it matters.
 */
export function useUnsavedWorkWarning(hasWork: boolean): void {
  useEffect(() => {
    if (!hasWork) return undefined;
    const warn = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [hasWork]);
}
